import React from "react";
import { number, string } from "prop-types";
import styles from "./calendarItem.module.styl";
import { percentageLevels } from "utils/indicator/indicatorSettings";
import cx from "classnames";

export default function CalendarItem({
    groupCode,
    sportTypeName,
    schoolName,
    loadingPercent,
    height,
    position,
    rowWidth,
    offsetY,
    dataTestName,
}) {
    let indicatorStyles = percentageLevels.indicatorColorWithOverload(loadingPercent ?? 0);

    let container = {
        padding: `3px 4px 4px 4px`,
        borderRadius: `4px`,
        display: "grid",
        alignItems: "center",
        alignContent: "start",
        height: `calc(${height} * ${42.13 / 30}px)`,
        width: `calc((100% / ${rowWidth}) - 9px)`,
        left: `calc(${position - 1} * calc((100% / ${rowWidth})))`,
        top: offsetY !== 0 ? `calc((${offsetY} * ${32 / 30}px))` : "",
        position: `absolute`,
        zIndex: 900,
        flexFlow: "column wrap",
        overflow: "hidden",
        borderTop: `1px solid ${indicatorStyles.color}`,
    };

    //если 2 строчки текста не поместятся, то отобразить их в одну линию
    if ((height * 42.13) / 30 < 30) {
        container = {
            ...container,
            display: "flex",
            flexFlow: "column wrap",
            overflow: "hidden",
            gap: "2px",
        };
    }

    return (
        <div
            className={cx(
                indicatorStyles.lightBackgroundStyle,
                indicatorStyles.leftBorderStyle,
                styles.indicatorBorder,
            )}
            style={container}
            data-test-name={dataTestName}
        >
            {
                //если одна строчка текста не помещается, то не показывать текст совсем
                (height * 42.13) / 30 <= 11 ? null : (
                    <>
                        <div className={styles.header}>
                            {groupCode}, {sportTypeName}
                        </div>
                        <div className={styles.schoolName}>{schoolName}</div>
                    </>
                )
            }
        </div>
    );
}

CalendarItem.propTypes = {
    groupCode: string.isRequired,
    loadingPercent: number.isRequired,
    schoolName: string.isRequired,
    sportTypeName: string.isRequired,
    height: number.isRequired,
    position: number.isRequired,
    rowWidth: number.isRequired,
    offsetY: number.isRequired,
    dataTestName: string
};